import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css'; // Core Swiper styles
import 'swiper/css/pagination'; // Pagination styles
import 'swiper/css/navigation'; // Navigation styles
import Footer from './Footer'; // Import the Footer component

// Import your images with unique variable names
import image1 from '../assets/end-femicide-5.jpeg';
import image2 from '../assets/end-femicide-7.jpeg';
import image3 from '../assets/end-femicide-13.jpeg';
import image4 from '../assets/end-femicide-10.jpg';

const Home = () => {
  return (
    <Box sx={{ height: '100vh', overflow: 'hidden' }}>
      {/* Image Slideshow */}
      <Box
        sx={{
          position: 'fixed', // Fix the slideshow to the viewport
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1, // Place it behind other content
        }}
      >
        <Swiper
          spaceBetween={0} // No space between slides
          centeredSlides={false} // disable the active slide
          autoplay={{
            delay: 3000, // Auto-play every 3 seconds
            disableOnInteraction: false, // Continue autoplay after user interaction
          }}
          pagination={{
            clickable: true, // Allow clicking on pagination bullets
          }}
          navigation={false} // disable navigation arrows
          modules={[Autoplay]} // Add Swiper modules
          style={{ width: '100%', height: '100%' }} // Ensure Swiper takes full viewport height
        >
          <SwiperSlide>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
              }}
            >
              <img
                src={image1}
                alt="Slide 1"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover', // Ensure the image covers the container
                  animation: 'zoom 10s infinite', // Apply zoom animation
                }}
              />
              {/* Dark Overlay */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)', // Dark overlay
                }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
              }}
            >
              <img
                src={image2}
                alt="Slide 2"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover', // Ensure the image covers the container
                  animation: 'zoom 10s infinite', // Apply zoom animation
                }}
              />
              {/* Dark Overlay */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)', // Dark overlay
                }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
              }}
            >
              <img
                src={image3}
                alt="Slide 3"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover', // Ensure the image covers the container
                  animation: 'zoom 10s infinite', // Apply zoom animation
                }}
              />
              {/* Dark Overlay */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)', // Dark overlay
                }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
              }}
            >
              <img
                src={image4}
                alt="Slide 4"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover', // Ensure the image covers the container
                  animation: 'zoom 10s infinite', // Apply zoom animation
                }}
              />
              {/* Dark Overlay */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)', // Dark overlay
                }}
              />
            </Box>
          </SwiperSlide>
        </Swiper>
      </Box>

      {/* Content Overlay */}
      <Container
        sx={{
          position: 'relative', // Position content above the slideshow
          zIndex: 1, // Ensure content is above the slideshow
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start', // Adjusted to push content upwards
          alignItems: 'center',
          textAlign: 'center',
          color: 'white', // Set text color to white for better visibility
          paddingTop: '10%', // Added padding to push content upwards
        }}
      >
        <Typography variant="h3" gutterBottom>
          Welcome to FemiZero
        </Typography>
        <Typography variant="body1">
          Report incidents, access resources, and get support.
        </Typography>
      </Container>

      {/* Footer with Logo */}
      <Footer />

      {/* Add CSS for zoom animation */}
      <style>
        {`
          @keyframes zoom {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Home;